import React from 'react';
import { ProgressBar } from '../../shared/ProgressBar';
import { Button } from '../../ui';

interface HeaderProps {
  progress: number;
  onClose: () => void;
}

export function Header({ progress, onClose }: HeaderProps) {
  return (
    <div className="bg-navy-800 px-2 sm:px-3 py-2 sm:py-2.5 border-b border-navy-700">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5">
          <h2 className="text-sm sm:text-base font-bold text-white">Checklist de Processos</h2>
        </div>
        <Button
          variant="ghost"
          size="xs"
          onClick={onClose}
        >
          Fechar
        </Button>
      </div>
      {/* Substitui a barra manual pelo ProgressBar com estilos equivalentes */}
      <ProgressBar
        value={progress}
        trackClassName="w-full h-2 bg-navy-700 rounded-full overflow-hidden"
        indicatorClassName="h-full bg-yellow-400 transition-all duration-300"
      />
      <div className="flex justify-between text-xs text-gray-400 mt-1">
        <span>Progresso</span>
        <span>{Math.round(progress)}%</span>
      </div>
    </div>
  );
}